import { createFileRoute, redirect } from "@tanstack/react-router";
import { useEffect } from "react";

import { UsagePage } from "../components/usage/UsagePage";
import { recordVisitedOrg, useActiveOrgId, useOrgs } from "../state/orgs";

/**
 * The tenant-scoped usage page — `/$org/usage`, matching inbox and settings.
 *
 * The org segment is not decoration here: usage is read per organization, so
 * the tenant whose spend is on screen belongs in the URL where it is visible,
 * bookmarkable and impossible to infer wrongly. The page reads it back through
 * `useActiveOrgId` and sends it with the query; the server re-checks it against
 * the session's memberships.
 */
function UsageRouteView() {
  const activeOrgId = useActiveOrgId();
  const { orgs } = useOrgs();

  // Visiting an org's usage keeps it the active tenant, matching inbox.
  useEffect(() => {
    if (activeOrgId && orgs.some((org) => org.id === activeOrgId)) {
      recordVisitedOrg(activeOrgId);
    }
  }, [activeOrgId, orgs]);

  return <UsagePage />;
}

export const Route = createFileRoute("/$org/usage")({
  beforeLoad: async ({ context }) => {
    if (
      context.authGateState.status !== "authenticated" &&
      context.authGateState.status !== "hosted-static"
    ) {
      throw redirect({ to: "/pair", replace: true });
    }
  },
  component: UsageRouteView,
});
